@let isUserThemselves = !!(isUserSelf$ | async);
@let telegramError = userFormGroup.controls.telegramLogin.errors?.['telegramLogin'];
@let availableRoles = (availableRoles$ | async) ?? [];

<div class="user-modal__header">
  <h1 class="user-modal__title">{{ modalData.title | translate }}</h1>

  @if (isEditingMode) {
    <div
      class="user-modal__user-status status-chip"
      [libSkeleton]="!isUserInfoLoaded()"
      [class.status-chip--active]="userStatus?.id === UserStatusEnum.Active"
      [class.status-chip--blocked]="userStatus?.id === UserStatusEnum.Blocked"
    >
      {{ userStatus?.name }}
    </div>
  }
</div>

<form
  class="user-modal"
  [formGroup]="userFormGroup"
  (ngSubmit)="onSubmit()"
>
  <!-- Имя -->
  <lib-input
    class="user-modal__input"
    type="text"
    formControlName="firstName"
    [placeholder]="'monitoring.users.modal.first-name' | translate"
    [label]="'monitoring.users.modal.first-name' | translate"
    [libSkeleton]="isUserProcessing()"
    [readonly]="isReadonly"
  />

  <!-- Фамилия -->
  <lib-input
    class="user-modal__input"
    type="text"
    formControlName="lastName"
    [placeholder]="'monitoring.users.modal.last-name' | translate"
    [label]="'monitoring.users.modal.last-name' | translate"
    [libSkeleton]="isUserProcessing()"
    [readonly]="isReadonly"
  />

  <!-- Почта -->
  <lib-input
    class="user-modal__input"
    type="email"
    formControlName="email"
    [placeholder]="'monitoring.users.modal.email' | translate"
    [label]="'monitoring.users.modal.email' | translate"
    [libSkeleton]="isUserProcessing()"
    [readonly]="isReadonly"
  />

  <!-- Telegram -->
  <lib-input
    class="user-modal__input"
    type="text"
    formControlName="telegramLogin"
    [placeholder]="'monitoring.users.modal.telegram' | translate"
    [label]="'monitoring.users.modal.telegram' | translate"
    [libSkeleton]="isUserProcessing()"
    [readonly]="isReadonly"
  />

  @if (telegramError) {
    <p
      class="user-modal__error"
      aria-live="polite"
    >
      {{ telegramError | translate }}
    </p>
  }

  <lib-select
    class="user-modal__input"
    labelTranslateKey="monitoring.users.modal.role"
    [options]="availableRoles"
    formControlName="role"
    [isClearable]="false"
    [fullWidth]="true"
    [libSkeleton]="isUserProcessing()"
    [isOptionListLoading]="isRoleListLoading()"
    (scrolled)="loadMoreRoles()"
  />

  <!-- Actions -->
  <div class="user-modal__actions">
    @if (isEditingMode && !isUserThemselves) {
      <div class="user-modal__icon-buttons">
        @if (canManageUsers()) {
          <lib-icon-button
            buttonStyle="filled"
            (click)="deleteUser()"
            [disabled]="invalidFormData || isUserProcessing()"
            [title]="'monitoring.users.modal.delete-user' | translate"
            [libSkeleton]="isUserProcessing()"
            icon="trash"
            [size]="24"
            type="button"
          />
        }

        @if (canManageUsers()) {
          <lib-icon-button
            buttonStyle="filled"
            icon="refresh"
            [disabled]="invalidFormData || isUserProcessing()"
            [title]="'monitoring.users.modal.reset-password' | translate"
            [libSkeleton]="isUserProcessing()"
            (click)="resetPassword()"
            [size]="24"
            type="button"
          />
        }

        @if (canBlockUsers()) {
          <lib-icon-button
            buttonStyle="filled"
            (click)="toggleUserBlockingState()"
            [disabled]="invalidFormData || isUserProcessing()"
            [title]="
              userStatus?.id === UserStatusEnum.Blocked
                ? ('monitoring.users.modal.unblock-user' | translate)
                : ('monitoring.users.modal.block-user' | translate)
            "
            [libSkeleton]="isUserProcessing()"
            [icon]="userStatus?.id === UserStatusEnum.Blocked ? 'user' : 'user-block'"
            [size]="24"
            type="button"
          />
        }
      </div>
    }

    @if (canManageUsers()) {
      <lib-button
        class="user-modal__submit-button"
        [disabled]="invalidFormData || isUserProcessing()"
        [libSkeleton]="isUserProcessing()"
        buttonSize="large"
        buttonType="submit"
      >
        {{
          (isCreatingMode
            ? 'monitoring.users.modal.create-user'
            : 'monitoring.users.modal.save-edits'
          ) | translate
        }}
      </lib-button>
    }
  </div>
</form>
